import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22Fonts.ts%22,%22import%22:%22Bricolage_Grotesque%22,%22arguments%22:[{%22subsets%22:[%22latin%22],%22variable%22:%22--dr-font-display%22}],%22variableName%22:%22displayFont%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Bricolage Grotesque', 'Bricolage Grotesque Fallback'",
        fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
